import React from 'react'
import { Card, SvgContent, TextContent } from './StyledComponents';
import { SvgIcons } from './SvgComponents';
import px2vw from '../../utils/px2vw';
import parse from 'html-react-parser';

const index = (props) => {

    function getanimationDirection() {
        let result = '';
        if (props.svgonToporBottom + props.alignSvgLeftorRight == "TopLeft") {
            result = 'radial-gradient(circle farthest-corner at 10% 10%, rgba(233, 86, 126, 1) 25%, rgba(227, 44, 94, 1) 25%);';
        }
        if (props.svgonToporBottom + props.alignSvgLeftorRight == "BottomRight") {
            result = 'radial-gradient(circle farthest-corner at 90% 90%, rgba(233, 86, 126, 1) 25%, rgba(227, 44, 94, 1) 25%);';
        }
        if (props.svgonToporBottom + props.alignSvgLeftorRight == "BottomLeft") {
            result = 'radial-gradient(circle farthest-corner at 10% 90%, rgba(233, 86, 126, 1) 25%, rgba(227, 44, 94, 1) 25%);';
        }
        if (props.svgonToporBottom + props.alignSvgLeftorRight == "TopRight") {
            result = 'radial-gradient(circle farthest-corner at 90% 10%, rgba(233, 86, 126, 1) 25%, rgba(227, 44, 94, 1) 25%);';
        }
        return result
    };

    function getboldedText() {
        var str = props.text;
        var substr = props.highlightText;
        var ress = parse(str.replace(substr, '<b>' + substr + '</b>'));
        return ress;
    }

function getSvgSize() {
    let svgsize = px2vw(60);
    if (window.innerWidth <= 425) {
        svgsize = px2vw(200);
    } 
    return svgsize;
}


    return (
        <Card bgColor="white" aligSvgTopOrBottom={props.svgonToporBottom} animationDirection={getanimationDirection()}>
            <SvgContent aligSvgLeftorRight={props.alignSvgLeftorRight}>
                <SvgIcons pageshow={props.svgIconName} size={getSvgSize()}></SvgIcons>
            </SvgContent>
            <TextContent>{getboldedText()}</TextContent>
        </Card>
    )
}

export default index
